import React, { useState, useEffect } from 'react';
import OtpPage from '../../../components/OtpPage/OtpPage';
import { login, confirmOtp } from '../../../common/constants/api';
import { setToken } from '../../../common/utils/auth-utils';
const HeroImage = '/images/updated.png';
const Logo = '/images/logo-48.png';
const Logo2x = '/images/logo-192.png';
const Money = '/images/icons/Money.svg';
const Approval = '/images/icons/Approval.svg';
const Trust = '/images/icons/Trust.svg';
const Hand = '/images/icons/Hand.svg';
const Experian = '/images/icons/Experian.svg';
const Call = '/images/icons/call.svg';
const Mail = '/images/icons/mail.svg';
import { navigate } from 'gatsby';
import SignIn from '../../../components/SignIn/SignIn';
import './Registration.css';
import FormikWizard from 'formik-wizard';
import steps from './steps';
import { getUserProfile } from '../../../common/constants/api';
import Steps from './steps';
import { useQueryParams, NumberParam, StringParam } from 'use-query-params';
import Modal from '../../../common/components/Modal/modal';
const footerItems = [
  {
    logo: {
      src: Money,
      alt: 'Money'
    },
    caption: '1 Application - > 50 + Lenders'
  },
  {
    logo: {
      src: Approval,
      alt: 'Approval'
    },
    caption: 'Instant Approval'
  },
  {
    logo: {
      src: Trust,
      alt: 'Trust'
    },
    caption: 'Trusted by 1,00,000+ Customers'
  },
  {
    logo: {
      src: Hand,
      alt: 'Hand'
    },
    caption: '500 + Cr disbursed'
  },
  {
    logo: {
      src: Experian,
      alt: 'Experian',
      className: 'h-8'
    }
  }
];
function FormWrapper({
  children,
  isLastStep,
  status,
  values,
  setStatus,
  goToPreviousStep,
  canGoBack,
  wizard,
  err,
  actionLabel,
  isSubmitting
}) {
  let url = new URL(window.location?.href);
  let isBpLogin = url.searchParams.get('bplogin');

  const [btnId, setbtnId] = useState(isBpLogin ? 1 : 2);
  const [show, setShow] = useState(false);
  return (
    <div className=" relative flex flex-wrap flex-col items-end ">
      <div className="flex-1 w-full flex flex-wrap flex-col md:flex-row h-auto relative overflow-y-hidden">
        <div className="flex flex-col w-full mt-5 lg:w-4/4  justify-center lg:items-start overflow-y-hidden">
          <div className=" flex-1 bg-white h-full   pt-2 md:pt-4 w-full text-center overflow-y-hidden font-normal">
            <div className="flex-1 relative pb-2 font-roboto font-normal text-black-100">
              <div className="flex-1 pb-2 mt-5 w-full  max-w-xs mx-auto text-left">
                <div className="inline-flex block rounded z-10 border border-orange-500 w-full ">
                  <button
                    type="button"
                    className={
                      (btnId === 1 ? 'btnActive text-white' : '') +
                      ' block rounded-l p-3 z-0  w-1/2 h-full '
                    }
                    onClick={() => {
                      setbtnId(1);
                    }}
                  >
                    Sign in
                  </button>
                  <button
                    type="button"
                    className={
                      (btnId === 2 ? 'btnActive text-white' : '') +
                      ' block rounded-r p-3 z-0 w-1/2 h-full '
                    }
                    onClick={() => {
                      setbtnId(2);
                      setShow(false);
                    }}
                  >
                    Sign up
                  </button>
                </div>
              </div>
            </div>
            {wizard.step.id == 'otp' && btnId !== 1 ? (
              <OtpPage
                wizard={wizard}
                values={values}
                previousStep={goToPreviousStep}
              />
            ) : (
              ''
            )}
            {btnId === 1 ? (
              <SignIn />
            ) : wizard.step.id !== 'otp' ? (
              children
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
      {btnId == 2 && wizard.step.id !== 'otp' ? (
        <Modal show={show} setShow={setShow} xl={true}>
          <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/Walix33bWr4"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </Modal>
      ) : null}
    </div>
  );
}
const Registration = () => {
  //const [num, setNum] = useQueryParam('x', NumberParam);
  const [invitevalues, setInvite] = useQueryParams({
    email: StringParam,
    phone: NumberParam,
    firstName: StringParam,
    lastName: StringParam,
    invitationId: StringParam,
    expiryTime: StringParam,
    hashValue: StringParam
  });
  const [updatedSteps, updateSteps] = useState(Steps);
  useEffect(() => {
    const getUserData = async Steps => {
      try {
        updateSteps(
          Steps.map(step => {
            if (step.id === 'signup') {
              step.initialValues.firstName = invitevalues?.firstName || '';
              step.initialValues.lastName = invitevalues?.lastName || '';
              step.initialValues.email = invitevalues?.email || '';
              step.initialValues.mobile = invitevalues?.phone || '';
              step.initialValues.invitationId =
                invitevalues?.invitationId || '';
              step.initialValues.hashValue = invitevalues?.hashValue || '';
              step.initialValues.expiryTime = invitevalues?.expiryTime || '';
            }
            return step;
          })
        );
      } catch (err) {
        return err.message;
      }
    };
    getUserData(Steps);
  }, [Steps]);
  const handleSubmit = React.useCallback(values => {
    return regisrerOtp(values.otp, values.signup);
  }, []);
  let regisrerOtp = async (sectionValues, formValues) => {
    const values = {};
    if (formValues.mobile) {
      values.phone = formValues.mobile;
      values.email = formValues.email;
      values.mobileOtp = sectionValues.mobileOtp;
      values.emailOtp = sectionValues.emailOtp;
      try {
        await confirmOtp(values, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        try {
          let res = await login({
            username: formValues.mobile,
            userType: 0,
            password: formValues.password
          });
          let [id, token, username, userType] = [
            res.id,
            res.token,
            res.username,
            res.userType
          ];
          await setToken({ id, token, username, userType });
          let resp = await getUserProfile();
          localStorage.setItem('userData', JSON.stringify(resp));
          // globalUserData.userData = resp;
          navigate('/app/kyc');
        } catch (err) {
          return err.response?.data;
        }
      } catch (err) {
        return err.response?.data;
      }
    }
  };
  return (
    <FormikWizard
      steps={updatedSteps}
      onSubmit={handleSubmit}
      render={FormWrapper}
    />
  );
};
export default Registration;
